import React, {useState} from 'react';
import {Plus, TagText} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import {InputContainer, MultipleSearch} from "finform";

const CategoryFilter = ({
                            placeholder,
                            options,
                            items,
                            setItems,
                        }) => {

    const [filter, setFilter] = useState(false);
    const [search, setSearch] = useState('');

    const handleOnChange = (newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'select-option':
            case 'remove-value':
            case 'pop-value':
                setItems(newValue);
                break;
            default:
                break;
        }
    };

    const handleCreate = (newValue) => {
        // Можно добавить логику создания новых тегов при allowAdd={true}
    };

    const onBlur = () => {
        setFilter(false);
    };


    const tooltipContent = items.map(tag => tag.label).join(', ');

    return (
        <>
            {filter ? (
                <div style={{
                    alignItems: 'center',
                    display: 'flex'
                }}>
                    <InputContainer
                        style={{
                            width: '120px',
                            minHeight: '24px',
                            lineHeight: '24px',
                            fontSize: '14px',
                            borderRadius: '8px',
                            padding: '0',
                            background: '#fff',
                            boxShadow: 'rgb(38 38 38 / 4%) 0px 1px 2px, rgb(38 38 38 / 16%) 0px 4px 8px',
                        }}
                    >
                        <MultipleSearch
                            placeholder={placeholder}
                            options={options}
                            values={items}
                            search={search}
                            onSearch={setSearch}
                            allowAdd={false}
                            onChange={handleOnChange}
                            handleCreate={handleCreate}
                            onBlur={onBlur}
                        />
                    </InputContainer>
                </div>
            ) : items.length > 0 ? (
                <TagText data-tooltip-content={tooltipContent} onClick={() => setFilter(true)}>
                    {items.length === 1
                        ? items[0].label
                        : `${items[0].label} +${items.length - 1}`}
                </TagText>
            ) : (
                <Plus onClick={() => setFilter(true)}/>
            )}
        </>
    );
};

export default CategoryFilter;